import { render, staticRenderFns } from "./PXQuestionsPage.vue?vue&type=template&id=7e92dde4"
import script from "./PXQuestionsPage.vue?vue&type=script&lang=js"
export * from "./PXQuestionsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports